<template>
  <div class="flex flex-col md:flex-row items-start w-full md:max-w-lg gap-4">
    <div class="w-full">
      <input
        type="email"
        placeholder="Enter your email"
        class="px-4 py-3 border border-gray-300 bg-white rounded-lg w-full"
      />
      <Button class="py-6 cursor-pointer md:hidden inline-flex mt-2 w-full" @click="subscribe()">Subscribe</Button>
      <p class="text-xs text-gray-500 mt-2">
        We care about your data in our <a href="/privacy-policy" class="text-primary underline">privacy policy</a>
      </p>
    </div>
    <Button size="lg" class="py-6 cursor-pointer hidden md:inline-flex" @click="subscribe()">Subscribe</Button>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';

const subscribe = () => {
  // TODO: Placeholder function for subscribe button action (LAYUP-3351)
  // eslint-disable-next-line no-console
  console.log('Subscribe button clicked');
};
</script>
